<ng-container *ngIf="scorecard$ | async as activeScorecards">
  <div class="mt-4" *ngIf="activeScorecards.length > 0">
    <div class="container">
      <div class="row">
        <ng-container *ngFor="let scorecard of activeScorecards">
          <div class="col-lg-4 col-12 mb-4" *ngIf="!scorecard.Hidden">
            <ng-container [ngTemplateOutlet]="scorecardView" [ngTemplateOutletContext]="{ scorecard: scorecard }"></ng-container>
          </div>
        </ng-container>
      </div>
    </div>
  </div>
  <ng-container *ngIf="showPlaceholder">
    <div class="container challenges-placeholder" *ngIf="activeScorecards.length == 0">
      <!--Scorecard Placeholder-->
      <div class="no-items m-0 no-results-placeholder-div">
        <div
          class="svg svg-info vs-svg ms-auto me-auto"
          fgbAnimateSvg
          [inlineSVG]="'assets/images/placeholders/Challenges.svg'"
        ></div>
        <div class="no-results-placeholder">{{ 'scorecards.placeholder.description' | translate }}</div>
      </div>
    </div>
  </ng-container>
</ng-container>

<ng-template #scorecardView let-scorecard="scorecard">
  <ng-container [ngSwitch]="scorecard.ScoreCardDisplayType">
    <ng-container *ngSwitchCase="scorecardDisplayType.punchcardView">
      <fgbcl-scorecard-punchcard-view
        [icon]="icon"
        [scorecard]="scorecard"
        [confettiColors]="confettiColors"
        [isSponsorInBody]="isSponsorInBody"
      ></fgbcl-scorecard-punchcard-view>
    </ng-container>
    <ng-container *ngSwitchCase="scorecardDisplayType.soloAction">
      <fgbcl-scorecard-punchcard-view
        [icon]="icon"
        [scorecard]="scorecard"
        [confettiColors]="confettiColors"
        [isSponsorInBody]="isSponsorInBody"
      ></fgbcl-scorecard-punchcard-view>
    </ng-container>
    <ng-container *ngSwitchCase="scorecardDisplayType.singleAction">
      <fgbcl-scorecard-punchcard-view
        [icon]="icon"
        [scorecard]="scorecard"
        [confettiColors]="confettiColors"
        [isSponsorInBody]="isSponsorInBody"
      ></fgbcl-scorecard-punchcard-view>
    </ng-container>
    <ng-container *ngSwitchCase="scorecardDisplayType.milestoneProgressBarView">
      <fgbcl-milestones-progress-view
        [icon]="icon"
        [originScorecard]="scorecard"
        [confettiColors]="confettiColors"
        [isSponsorInBody]="isSponsorInBody"
      ></fgbcl-milestones-progress-view>
    </ng-container>
    <ng-container *ngSwitchCase="scorecardDisplayType.numberView">
      <fgbcl-scorecard-number-view
        [icon]="icon"
        [scorecard]="scorecard"
        [confettiColors]="confettiColors"
        [isSponsorInBody]="isSponsorInBody"
      ></fgbcl-scorecard-number-view>
    </ng-container>
    <ng-container *ngSwitchCase="scorecardDisplayType.streakView">
      <fgbcl-scorecard-streak [scorecard]="scorecard" [isSponsorInBody]="isSponsorInBody"></fgbcl-scorecard-streak>
    </ng-container>
  </ng-container>
</ng-template>
